import Colors from 'enums/Colors';
import { fetchStorageFile } from 'hooks/StoreFiles';
import React from 'react';
import styled from 'styled-components';

const Styled = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        gap: 10px;
        font-family: 'Barlow', sans-serif;
    `,

    Card: styled.div`
        width: 400px;
        border-radius: 20px;
        padding: 20px;
        background-color: ${Colors.White};

        @media screen and (max-width: 1280px) {
            width: 280px;
        }
    `,

    Row: styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
        font-weight: bold;
    `,

    Column: styled.div`
        display: flex;
        flex-direction: column;
        gap: 1rem;
    `,
};

export enum AdEbookEnum {
    SMALL = 'SMALL',
    FULL = 'FULL',
}

interface IAdEbookProps {
    styles?: React.CSSProperties;
    type: AdEbookEnum;
    imgQRCode?: string;
    description?: string;

}

const AdEbook: React.FC<IAdEbookProps> = ({ type, styles }) => {
    if (type === AdEbookEnum.SMALL) {
        return (
            <Styled.Container style={styles}>
                <Styled.Card style={{width: "210px"}}>
                    {/* Conteúdo do anúncio do ebook em formato pequeno */}

                    <img
                        width={'80px'}
                        height={'100%'}
                        src={fetchStorageFile('anexo_storage_files_10200124058940463069.png_2025-11-18-1763486762814.png')}
                        alt=""
                    />
                    <img
                        width={'80px'}
                        src={fetchStorageFile('anexo_storage_files_2537951731790736943.jpg_2025-11-18-1763487222152.jpg')}
                        alt=""
                    />
                    <p style={{ fontSize: '12px' }}>
                        Este livro conta com versões <br />
                        acessíveis em Libras e audiolivro <br />
                        com audiodescrição. Utilize o QR
                        <br />
                        Code no interior para acessá-las.
                    </p>
                </Styled.Card>
            </Styled.Container>
        );
    }

    return (
        <Styled.Container style={styles}>
            <Styled.Card>
                <Styled.Row style={{ justifyContent: 'space-between' }}>
                    <Styled.Column>
                        <Styled.Row>
                            <img
                                width={'80px'}
                                height={'100%'}
                                src={fetchStorageFile('anexo_storage_files_10200124058940463069.png_2025-11-18-1763486762814.png')}
                                alt=""
                            />
                            <p>
                                Acesse a versão <br /> deste livro em Libras
                            </p>
                        </Styled.Row>
                        <Styled.Row>
                            <img
                                width={'80px'}
                                height={'100%'}
                                src={fetchStorageFile('anexo_storage_files_2537951731790736943.jpg_2025-11-18-1763487222152.jpg')}
                                alt=""
                            />
                            <p>Ouça a versão em áudio deste livro, narrada com acessibilidade.</p>
                        </Styled.Row>
                    </Styled.Column>
                    <img
                        width={'100px'}
                        src={fetchStorageFile('anexo_storage_files_14204880004148354930.png_2025-11-18-1763492576846.png')}
                        alt=""
                    />
                </Styled.Row>
                <p
                    style={{
                        textAlign: 'center',
                        fontWeight: 'bold',
                        overflowWrap: 'anywhere',
                        wordBreak: 'break-all',
                    }}
                >
                    Caso tenha dificuldades com QR Code, acesse:{' '}
                    <a
                        href="https://humane.institutoayrtonsenna.org.br/ebooks/plano-anual-instituto-ayrton-senna-2025"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: 'inherit', textDecoration: 'underline', overflowWrap: 'anywhere', wordBreak: 'break-all' }}
                    >
                        https://humane.institutoayrtonsenna.org.br/ebooks/plano-anual-instituto-ayrton-senna-2025
                    </a>
                </p>
            </Styled.Card>
        </Styled.Container>
    );
};

export default AdEbook;
